import { SourceDataVerificationPermission } from '@/api/dtos';
import Breadcrumbs from '@/components/layouts/Breadcrumbs';
import PageTitle, { TITLE_BASE, TITLE_SEPARATOR } from '@/components/layouts/PageTitle';
import TrialsContext from '@/contexts/data/TrialsContext';
import usePermissions from '@/hooks/utility/usePermissions';
import { faDna } from '@fortawesome/duotone-light-svg-icons';
import { Divider, List, ListItemButton, ListItemText, Paper, Typography, useTheme } from '@mui/material';
import { FC, Fragment, useContext, useMemo } from 'react';
import { Link, Navigate } from 'react-router-dom';

const Trials: FC = () => {
    const { data: trials, loading: trialLoading } = useContext(TrialsContext);

    const theme = useTheme();
    const { data: [hasAccess] = [], loading: permissionsLoading, validating: permissionsValidating} = usePermissions(
        [SourceDataVerificationPermission.Access], 
        trialLoading,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        {
            revalidateOnFocus: false
        }
    );

    const breadcrumbs = useMemo(() => {
        return [
            {
                label: 'Trials',
                link: `/`,
                icon: faDna
            }
        ];
    }, []);

    if (!hasAccess && !permissionsLoading && !permissionsValidating) {
        return (
            <Navigate to='/error/403' />
        )
    }

 

    return (
        <>
           <Breadcrumbs 
                breadcrumbs={breadcrumbs}
            />
                    
            <PageTitle title={`Trials${TITLE_SEPARATOR}${TITLE_BASE}`} />
            <Typography color={theme.palette.secondary.main} variant="h1" gutterBottom>
                Trials
            </Typography>
            <Paper>
                <List disablePadding>
                    {
                        trials?.map((x, i, a) => {
                            return (
                                <Fragment key={x.id}>
                                    <ListItemButton component={Link} to={`/${x.code}/participants`}>
                                        <ListItemText primary={x.name} />
                                    </ListItemButton>
                                    { i < (a.length - 1) && <Divider />}
                                </Fragment>
                            );
                        })
                    }
                    
                </List>
            </Paper>
        </>
    );
}

export default Trials;